import { mapActions } from 'vuex'

export default {
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        exit(callback, showConfirmation = true) {

            const exit = () => {

                this.unsetShowExitFormConfirmation()

                if (typeof callback === 'function') {

                    callback()
                }
            }

            if (showConfirmation) {

                this.showExitConfirmation(async () => exit())
            }
            else {

                exit()
            }
        },
    }
}